export default (obj) => {
  const newObj = obj;

  Object.keys(obj).forEach((key) => (newObj[key] === undefined ? delete newObj[key] : {}));

  return JSON.parse(JSON.stringify(newObj));
};
